import React from "react";
import { Box } from "@mui/material";
import noPic from "../../assets/no-pic.png";

const SmallCategorySlider = ({ categories = [], onCategoryClick, compact = false }) => {
  // Only show categories where show_in_home is true
  const showInHomeCategories = categories.filter(category => category.show_in_home);

  if (showInHomeCategories.length === 0) {
    return null;
  }

  const tileHeight = compact ? "75px" : "calc(82px + 3mm)";

  return (
    <Box sx={{
      margin: compact ? { xs: "0", md: "4px 0 0 0" } : { xs: "0.5rem 0", md: "4px 0 0 0" },
      padding: { xs: "0 17px", md: "0" },
      ...(compact && { position: "relative", zIndex: 4, overflow: "visible" }),
    }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "space-between", md: "space-between" },
          gap: { xs: compact ? "5px" : "2.5px", md: "6px" },
          alignItems: "stretch",
          overflowX: compact ? "visible" : "auto",
          overflowY: "visible",
          padding: compact ? { xs: "6px 0", md: "4px 0" } : { xs: "0.5rem 0", md: "4px 0" },
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {showInHomeCategories.slice(0, 5).map((category, index) => (
          <React.Fragment key={category.id}>
            {/* Outer wrapper: carries shadow + borderRadius, no overflow:hidden so shadow is never clipped */}
            <Box
              className="small-cat-item"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: { xs: compact ? "calc(20% - 4px)" : "calc(20% - 2px)", md: undefined },
                flex: { xs: undefined, md: 1 },
                cursor: "pointer",
                padding: 0,
                flexShrink: 0,
                borderRadius: compact ? "7px" : "6px",
                ...(compact && {
                  boxShadow: "0 3px 8px rgba(0,0,0,0.20), 0 1px 3px rgba(0,0,0,0.12)",
                  position: "relative",
                  zIndex: 2,
                }),
              }}
              onClick={() => onCategoryClick(category.id)}
            >
              {/* Inner box: clips the image to the rounded corners, no shadow here */}
              <Box
                sx={{
                  width: "100%",
                  height: { xs: tileHeight, md: undefined },
                  aspectRatio: { xs: undefined, md: "1 / 1" },
                  overflow: "hidden",
                  borderRadius: compact ? "7px" : "6px",
                  flexShrink: 0,
                }}
              >
                <img
                  src={category.image || noPic}
                  alt={category.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            {/* Vertical separator — hidden in compact mode, replaced by gap */}
            {index < 4 && !compact && (
              <Box
                sx={{
                  width: "1px",
                  backgroundColor: "#e0e0e0",
                  height: { xs: tileHeight, md: "100%" },
                  alignSelf: "stretch",
                  flexShrink: 0,
                  opacity: 0.6,
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(SmallCategorySlider);
